const EventPage = '/studio-director-embed/teams/:teamId/events/:eventId';
const BroadcastPage = `${EventPage}/broadcasts/:broadcastId`;
const JoinPage = `${BroadcastPage}/join`;

const AppPaths = {
  EventPage,
  BroadcastPage,
  JoinPage
};

export default AppPaths;
